// extracted by mini-css-extract-plugin
export default {"root":"Favorites_root__oE6vA","descriptionWrapper":"Favorites_descriptionWrapper__CSbTX","doctor":"Favorites_doctor__gnQZX","items":"Favorites_items__TelUa"};